var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgNextjsLogo = function SvgNextjsLogo(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Next.js",
    width: 132,
    height: 80,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 86 52",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.292 13.562h16.22v1.292H21.78v9.725h13.855v1.293H21.779v10.677h14.902v1.292H20.293V13.562Zm17.674 0h1.723l7.637 10.677 7.806-10.677L65.75 0 48.306 25.361l8.99 12.48h-1.792l-8.178-11.357-8.21 11.357h-1.758l9.056-12.48-8.448-11.799Zm19.971 1.292v-1.292h18.484v1.292h-8.515V37.84H66.42V14.854h-8.481ZM0 13.562h1.859L27.487 52 16.896 37.84 1.554 15.399l-.067 22.443H0V13.562Zm76.272 22.596a.526.526 0 0 1-.532-.54c0-.305.228-.541.532-.541.307 0 .531.236.531.541 0 .305-.224.54-.531.54Zm1.46-1.422h.797c.01.432.326.722.788.722.517 0 .81-.312.81-.896V30.86h.81v3.705c0 1.053-.607 1.66-1.613 1.66-.943 0-1.59-.589-1.59-1.49h-.001Zm4.265-.047h.803c.068.497.553.813 1.251.813.65 0 1.128-.338 1.128-.802 0-.4-.303-.64-.995-.802l-.672-.163c-.944-.222-1.374-.68-1.374-1.449 0-.933.759-1.553 1.898-1.553 1.06 0 1.834.62 1.88 1.502h-.788c-.075-.482-.495-.784-1.103-.784-.64 0-1.067.309-1.067.78 0 .374.275.589.956.748l.574.142c1.07.25 1.512.686 1.512 1.473 0 1.002-.775 1.63-2.01 1.63-1.158 0-1.936-.599-1.993-1.535Z",
    fill: "#646E73"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#646E73"
  })));
};

export default SvgNextjsLogo;